import React, { PropTypes, Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";

interface FeatureProps {
  children: HTMLElement;
  placeholder?: HTMLElement;
  flag: string;
  features: any;
  redirect?: string;
}
class Feature extends React.Component<FeatureProps, {}> {
  render() {
    const { children, features, flag, redirect, placeholder } = this.props;

    if (features[flag]) {
      return React.Children.only(children);
    } else if (redirect) {
      return <Redirect to={redirect} />;
    } else if (placeholder) {
      return React.Children.only(placeholder);
    } else {
      return null;
    }
  }
}

function mapStateToProps(state: any, ownProps: any) {
  return {
    features: state.user.features
  };
}

export default connect(mapStateToProps)(Feature);



// WEBPACK FOOTER //
// ./client/modules/common/components/Feature/index.tsx